import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';


const TableNameCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);
    const [name, setName] = useState("");
    const [isParcel, setisParcel] = useState(false);
    const [isGst, setisGst] = useState(false);
    const [isSubmit, setisSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const clearForm = () => {
        setName("");
        setisParcel(false)
        setisGst(false)
    };

    const submitData = async (e) => {
        e.preventDefault();



        if (!name) {
            setErrorMessage("All fields are required!");
            return;
        }

        const CreateData = {
            Name: name,
            IsParcel: isParcel,
            GstNotApplicable: isGst,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('TableNameApi', CreateData, token)
            .then((response) => {
                console.log('Table Name Created success:', response);
                setSuccessMessage("Table Name Created successfully!");
                setErrorMessage("");
                clearForm();
                history.push('/TableNameIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Table Name Create error:', error);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h5 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',color:'black' }}>TABLE NAME CREATE</h5>
                        <Button
                            variant="contained"
                            style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                            onClick={submitData}
                        >
                            SAVE
                        </Button>

                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/TableNameIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px' }}
                        >
                            BACK TO LIST
                        </Button>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Table Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Table Name"
                                required
                                maxLength={20}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Include Parcel Charge?
                            </label>
                            <div className="inline-flex items-center">
                                <input
                                    type="checkbox"
                                    className="form-checkbox h-4 w-4 text-green-500 border-4 border-gray-400 rounded-md checked:bg-green-500 checked:border-transparent"
                                    name={isParcel}
                                    checked={isParcel}
                                    onChange={(e) => setisParcel(e.target.checked)}
                                />
                                <span className="ml-2">Include Parcel Charge?</span>
                            </div>
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                                Gst Not Applicable?
                            </label>
                            <div className="inline-flex items-center">
                                <input
                                    type="checkbox"
                                    className="form-checkbox h-4 w-4 text-green-500 border-4 border-gray-400 rounded-md checked:bg-green-500 checked:border-transparent"
                                    name={isGst}
                                    checked={isGst}
                                    onChange={(e) => setisGst(e.target.checked)}
                                />
                                <span className="ml-2">Gst Not Applicable?</span>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        </Fragment>
    );
}

export default TableNameCreate;

